<template>
  <v-flex xs12 md6>
    <v-card>
      <v-card-title>
        <v-icon left>mdi-arrow-decision-outline</v-icon>
        Signups by Campaign
        <v-spacer />
        <v-progress-circular v-if="signups.loading"
          indeterminate :size="20" :width="1"
          :color="themes.client.light.input"
        />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <apex
          v-if="!signups.loading"
          type="pie"
          width="100%"
          :height="400"
          :options="{
            labels: Object.keys(signups),
            colors,
            chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: true } },
            tooltip: { enabled: true },
            legend: { position: 'bottom' },
          }"
          :series="Object.values(signups)"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
// Data
import colors from '@/data/colors'

// Vue Component
export default {
  created() {
    Vue.$http.get(`client/organization/analytics/campaign_signups`).then(({ data }) => (this.signups = data))
  },
  data() {
    return {
      colors: colors.analytics,
      signups: { loading: true },
    }
  },
}
</script>
